export default __webpack_public_path__ + "static/media/3.05b369f2.png";